import { ChevronLeft, ChevronRight } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

function pageList(current, total) {
  const pages = new Set([1, total, current, current - 1, current + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  for (const p of sorted) { if (prev && p - prev > 1) out.push("…"); out.push(p); prev = p; }
  return out;
}

export function ClientPagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);
  return (
    <div data-testid="clients-pagination" className="flex flex-wrap items-center justify-between gap-4 px-1 py-3">
      <div className="flex items-center gap-4 text-sm text-[#475467]">
        <span data-testid="clients-pagination-summary">Showing {start}–{end} of {total} clients</span>
        <Select value={String(pageSize)} onValueChange={(v) => onPageSizeChange(Number(v))}>
          <SelectTrigger data-testid="clients-page-size" className="h-8 w-[130px] rounded-lg text-xs"><SelectValue /></SelectTrigger>
          <SelectContent>{[10, 25, 50, 100].map((n) => <SelectItem key={n} value={String(n)}>{n} per page</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-1">
        <button data-testid="clients-page-prev" disabled={page <= 1} onClick={() => onPageChange(page - 1)} className="h-8 w-8 grid place-items-center rounded-lg border border-[#E4E9F0] text-[#475467] disabled:opacity-40 hover:bg-[#F8FAFC]"><ChevronLeft size={15} /></button>
        {pageList(page, totalPages).map((p, i) => p === "…" ? (
          <span key={`e${i}`} className="h-8 w-8 grid place-items-center text-sm text-[#94A3B8]">…</span>
        ) : (
          <button key={p} data-testid={`clients-page-${p}`} onClick={() => onPageChange(p)} className={`h-8 w-8 grid place-items-center rounded-lg text-sm transition-colors ${p === page ? "bg-[#0C2347] text-white" : "text-[#475467] hover:bg-[#F8FAFC]"}`}>{p}</button>
        ))}
        <button data-testid="clients-page-next" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} className="h-8 w-8 grid place-items-center rounded-lg border border-[#E4E9F0] text-[#475467] disabled:opacity-40 hover:bg-[#F8FAFC]"><ChevronRight size={15} /></button>
      </div>
    </div>
  );
}
